module.exports = __webpack_public_path__ + "static/media/video_poster.2b1ccd82.jpg";